// opervex-frontend/src/routes/TenantRedirect.js

import { useLocation, useParams } from "react-router-dom";
import routes from ".";
import NotFoundPage from "../pages/NotFoundPage";

const TenantRedirect = () => {
  const location = useLocation();
  const { tenantId } = useParams();

  const pathname = location.pathname.replace(`/${tenantId}/`, "");

  const rotaExiste = routes.some((route) => {
    const cleanPath = route.path.replace(/^\/+/, "");
    return pathname.startsWith(cleanPath);
  });

  if (rotaExiste) return null;

  // Exibe página 404 estilizada
  return <NotFoundPage />;
};

export default TenantRedirect;
